<h2 mat-dialog-title class="add-participant-title">Teilnehmer hinzufügen</h2>

<mat-dialog-content class="add-participant-content">
  <div *ngIf="isLoading" class="add-participant-loading">
    <mat-icon class="add-participant-spinner">hourglass_empty</mat-icon>
    <span>Lade Benutzer...</span>
  </div>

  <div *ngIf="!isLoading">
    <mat-form-field appearance="outline" class="add-participant-select-field">
      <mat-label>Person auswählen</mat-label>
      <mat-select [(value)]="selectedUser" placeholder="Bitte wählen">
        <mat-option *ngFor="let user of filteredUsers" [value]="user">
          {{ getUserDisplayName(user) }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <p *ngIf="filteredUsers.length === 0" class="add-participant-empty">
      Keine weiteren Benutzer verfügbar.
    </p>
  </div>
</mat-dialog-content>

<mat-dialog-actions class="add-participant-actions">
  <button
    mat-raised-button
    color="primary"
    class="add-participant-btn"
    [disabled]="!selectedUser"
    (click)="onConfirm()">
    <mat-icon>person_add</mat-icon>
    <span>Hinzufügen</span>
  </button>
  <button
    mat-stroked-button
    class="add-participant-btn"
    (click)="onCancel()">
    Abbrechen
  </button>
</mat-dialog-actions>
